export interface IFile {
  fileId: string;
  urlFile: string;
  path: string;
  service: string;
  fileType: string;
  uidCreatedBy: string | null;
  uidUpdatedBy: string | null;
  createdAt: string;
  updatedAt: string;
}

export class FileModel {
  fileId: string;
  urlFile: string;
  path: string;
  service: string;
  fileType: string;
  uidCreatedBy: string | null;
  uidUpdatedBy: string | null;
  createdAt: Date;
  updatedAt: Date;

  constructor(data: IFile) {
    this.fileId = data.fileId;
    this.urlFile = data.urlFile;
    this.path = data.path;
    this.service = data.service;
    this.fileType = data.fileType;
    this.uidCreatedBy = data.uidCreatedBy ?? null;
    this.uidUpdatedBy = data.uidUpdatedBy ?? null;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
  }
}
